// Ask before something can't be undone: a Basecoat alert dialog on the native <dialog>.
import { btn, h } from './dom';

let seq = 0;

/** Resolves true when the person confirms; Cancel, Escape and closing all resolve false. Cancel has focus. */
export function confirmAction(opts: { title: string; description: string; confirm: string }): Promise<boolean> {
  const id = `confirm-${++seq}`;
  const cancel = h('button', btn('outline'), 'Cancel');
  const ok = h('button', btn('destructive'), opts.confirm);
  const dialog = h('dialog', { class: 'alert-dialog', role: 'alertdialog', 'aria-labelledby': `${id}-t`, 'aria-describedby': `${id}-d` },
    h('div', null,
      h('header', null, h('h2', { id: `${id}-t` }, opts.title), h('p', { id: `${id}-d` }, opts.description)),
      h('footer', null, cancel, ok)));
  document.body.append(dialog);
  return new Promise(resolve => {
    let confirmed = false;
    cancel.addEventListener('click', () => dialog.close());
    ok.addEventListener('click', () => { confirmed = true; dialog.close(); });
    dialog.addEventListener('close', () => { dialog.remove(); resolve(confirmed); });
    dialog.showModal();
    cancel.focus();
  });
}
